import { render, staticRenderFns } from "./WebhookEvents.vue?vue&type=template&id=d37e61d0"
import script from "./WebhookEvents.vue?vue&type=script&lang=js"
export * from "./WebhookEvents.vue?vue&type=script&lang=js"
import style0 from "./WebhookEvents.vue?vue&type=style&index=0&id=d37e61d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports